/* istanbul ignore file */
// This file is ignored from coverage for now since in the near future we will move this mapping to Vulcan

import Api, { HttpMethod } from './index';
import { IFromMelissaGetAddressResponse } from './dataMapper/melissaApiMapper';

interface IMelissaApiConfig {
  api: Api;
}

interface IMelissaGetAddressResponse {
  data: {
    data: {
      validateAddress: IMelissaGetAddressResponseEntry[]
    }
  }
}

interface IMelissaGetPostalCodeResponse {
  data: {
    data: {
      validatePostalCode: IMelissaGetAddressResponseEntry[]
    }
  }
}

export interface IMelissaGetAddressResponseEntry {
  administrativeArea?: string,
  countryName?: string,
  delivery?: string,
  deliveryline1?: string,
  deliveryline2?: string,
  deliveryline3?: string,
  full?: string,
  iso31662?: string,
  iso31663?: string,
  line1?: string,
  line2?: string,
  line3?: string,
  postalCode?: string,
  subAdministrativeArea?: string,
  locality?: string,
  subBuilding?: [],
}

export default class MelissaApi {
  private api: Api;

  constructor({ api }: IMelissaApiConfig) {
    this.api = api;
  }

  async getAddressSuggestionsFromPartialAddress(partialAddress: string, fields: string): Promise<IFromMelissaGetAddressResponse> {
    const response = await this.api.makeRequest(HttpMethod.POST, {
      body: {
        query: `query($partialAddress: String!) { validateAddress(partialAddress: $partialAddress) { ${fields} }}`, // eslint-disable-line @typescript-eslint/quotes
        variables: {
          partialAddress,
        },
      },
      options: {
        credentials: 'include',
      },
      url: '/api/2022-08/storefront/graphql',
    }, true) as IMelissaGetAddressResponse;

    return this.api.dataMapper.mapResponse('melissaApiMapper', response.data?.data?.validateAddress) as IFromMelissaGetAddressResponse;
  }

  async getAddressSuggestionsFromPostalCode(postalCode: string, fields: string, country: string): Promise<IFromMelissaGetAddressResponse> {
    const response = await this.api.makeRequest(HttpMethod.POST, {
      body: {
        query: `query($postalCode: String!, $country: String!) { validatePostalCode(postalCode: $postalCode, country: $country) { ${fields} }}`, // eslint-disable-line @typescript-eslint/quotes
        variables: {
          country,
          postalCode,
        },
      },
      options: {
        credentials: 'include',
      },
      url: '/api/2022-08/storefront/graphql',
    }, true) as IMelissaGetPostalCodeResponse;

    return this.api.dataMapper.mapResponse('melissaApiMapper', response.data?.data?.validatePostalCode) as IFromMelissaGetAddressResponse;
  }
}
